export default "__VITE_ASSET__DqqstdUQ__"